import { FC } from "react";
import { useField } from "react-final-form";

const FormError: FC<{ name: string; touch?: boolean }> = ({
  name,
  touch = true,
}) => {
  const {
    meta: { touched, error, submitError },
  } = useField(name, {
    subscription: { touched: true, error: true },
  });

  const checks = [error];
  if (touch) {
    checks.push(touched);
  }
  return checks.some((item) => !item) ? null : (
    <div className="text-red-700 mt-4 text-sm">{error}</div>
  );
};

export default FormError;
